import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<p>Loading...</p>\n",{ moduleName: "sh-www/templates/admin/productions/view-loading.hbs" })